module.exports = __webpack_public_path__ + "static/img/s407.6ad3ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s407.png
// module id = 559
// module chunks = 3